
import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
import Pop from "../components/blue-pop.vue";
import { langList } from "@/utils/multi-lang";
import {
  QuestionV2Object,
  QuestionV2
} from "@/lib/model/exambuilder/question-v2";
import {
  DimensionObject,
  QuestionDimension
} from "@/lib/model/exambuilder/dimension-v2";
import {
  StructExamScoreConfig,
  StructExamQuestionConfig
} from "@/lib/model/exambuilder/exam-v2";
import vuexStore from "@/store/vuex-store";
import BlankAnswer from "@/views/ai-builder/question-card-v2/blank-answer.vue";
import TooltipMaterials from "@/components/tooltip/index.vue";
import Inquiry from "@/components/inquiry/index.vue";

@Component({ components: { Pop, BlankAnswer, TooltipMaterials, Inquiry } })
export default class QuestionCardV2 extends Vue {
  @Prop({ type: QuestionV2, default: new QuestionV2() }) question!: QuestionV2; //题目model
  @Prop({ type: String, default: "" }) mode!: string; // 提卡模式 select = 选择模式; selected = 已经选择模式;score = 分数设置模式
  @Prop({ type: Array, default: null }) actions!: Array<any> | null;
  // 题目序号
  @Prop({ type: Number, default: 0 }) totalCount!: number;
  @Prop({ type: Number, default: 0 }) index!: number;
  @Prop({ type: Map, default: null }) dimensionMap!: Map<
    string,
    QuestionDimension
  >; // 维度map，需要使用维度数据时从map里取
  @Prop({ type: QuestionDimension, default: null })
  currentDimension!: QuestionDimension | null;
  @Prop({ type: Boolean, default: false }) showAllDimension!: boolean;
  @Prop({ type: Boolean, default: true }) canEditScore!: boolean;
  @Prop({ type: Array, default: null }) scoreConfigList!: Array<any> | null;
  @Prop({ type: StructExamQuestionConfig, default: null })
  questionConfig!: StructExamQuestionConfig | null;
  @Prop({ default: false, type: Boolean })
  setWeb!: boolean;
  showMoreActions = false;
  // 正在编辑的维度
  edittingDimension = "";
  // 正在编辑的选项
  edittingOption = "";

  sortTo = 1; //移至第几
  popShow = false; //排序框
  V = vuexStore;

  langList = langList;

  audioElement: any = "";

  selectQuestionScoreConfig: StructExamScoreConfig | null = null;
  blankQuestionScoreConfig: StructExamScoreConfig | null = null;
  filterdScoreConfig: Array<StructExamScoreConfig> = [];
  // 展开题卡编辑
  expand = false;
  // 追问
  visible = false;
  // 其他设置选项
  otherConfigOptions = [
    [
      {
        value: -1,
        label: "不限制"
      },
      {
        value: 3,
        label: "3秒"
      },
      {
        value: 5,
        label: "5秒"
      },
      {
        value: 10,
        label: "10秒"
      },
      {
        value: 15,
        label: "15秒"
      },
      {
        value: 20,
        label: "20秒"
      },
      {
        value: 25,
        label: "25秒"
      },
      {
        value: 30,
        label: "30秒"
      },
      {
        value: 60,
        label: "1分钟"
      },
      {
        value: 120,
        label: "2分钟"
      },
      {
        value: 180,
        label: "3分钟"
      }
    ],

    [
      {
        value: -1,
        label: "不限制"
      },
      {
        value: 60,
        label: "1分钟"
      },
      {
        value: 60 * 2,
        label: "2分钟"
      },
      {
        value: 60 * 3,
        label: "3分钟"
      },
      {
        value: 60 * 4,
        label: "4分钟"
      },
      {
        value: 60 * 5,
        label: "5分钟"
      },
      {
        value: 60 * 6,
        label: "6分钟"
      },
      {
        value: 60 * 10,
        label: "10分钟"
      },
      {
        value: 60 * 15,
        label: "15分钟"
      },
      {
        value: 60 * 20,
        label: "20分钟"
      },
      {
        value: 60 * 30,
        label: "30分钟"
      }
    ],

    [
      {
        value: -1,
        label: "不限制"
      },
      {
        value: 1,
        label: "1"
      },
      {
        value: 2,
        label: "2"
      },
      {
        value: 3,
        label: "3"
      },
      {
        value: 4,
        label: "4"
      },
      {
        value: 5,
        label: "5"
      }
    ]
  ];

  get hasFuScore() {
    const t = this.selectQuestionScoreConfig?.choiceQuestionScoreList;
    let flag = false;
    t?.forEach((d: any) => {
      if (d.score < 0) flag = true;
    });
    return flag;
  }
  get allFuScore() {
    const t = this.selectQuestionScoreConfig?.choiceQuestionScoreList;
    let flag = true;
    t?.forEach((d: any) => {
      if (d.score >= 0) flag = false;
    });
    return flag;
  }

  @Emit()
  closeOtherPop() {
    return this.question.questionId;
  }

  onCloseOtherPop(questionId: number) {
    if (questionId != this.question.questionId) {
      this.popShow = false;
    }
  }
  // 获得选择题config
  initSelectQuestionConfig() {
    if (this.filterdScoreConfig.length > 0 && this.question.isSingleSelect()) {
      this.selectQuestionScoreConfig = this.filterdScoreConfig[0];
      return this.selectQuestionScoreConfig;
    }
  }
  initBlankQuestionConfig() {
    if (this.filterdScoreConfig.length > 0 && this.question.isBlank()) {
      this.blankQuestionScoreConfig = this.filterdScoreConfig[0];
      return this.blankQuestionScoreConfig;
    }
  }

  playAudioDesc() {
    // 先停止其他音频
    const audioElements = document.querySelectorAll("audio");
    audioElements.forEach((audioElement: any) => {
      // 暂停其他audio用于后面判断当前audio的播放状态
      if (audioElement.id !== "audioDesc-" + this.question.questionId) {
        // 切换audio需要从头播放时放开下面
        // audioElement.setAttribute('src', audioElement.src)
        audioElement.pause();
      }
    });
    // 播放音频材料
    if (!this.audioElement) {
      this.audioElement = document.createElement("audio");
      document.body.appendChild(this.audioElement);
    }
    if (!this.audioElement.paused) {
      this.audioElement.pause();
    } else {
      // 需求暂停后不要从头播放，需要时去掉判断条件
      if (!this.audioElement.id && !this.audioElement.src) {
        this.audioElement.setAttribute(
          "id",
          "audioDesc-" + this.question.questionId
        );
        this.audioElement.setAttribute("src", this.question.audioDescUrl);
      }
      this.audioElement.play();
    }
  }

  initScoreConfig() {
    if (this.scoreConfigList) {
      this.filterdScoreConfig = this.scoreConfigList.filter(
        (config: StructExamScoreConfig) => {
          return config.questionId === this.question.questionId;
        }
      );
    } else this.filterdScoreConfig = [];
  }

  changeSelect() {
    this.change();
  }

  getInputClass(dimKey: string) {
    if (this.edittingDimension == dimKey) {
      return "dim-total-score-editting";
    } else
      return this.canEditScore
        ? this.currentDimension && this.currentDimension.dimensionKey == dimKey
          ? "dim-total-score-hightlight"
          : ""
        : "input-disable";
  }

  getOptionInputClass(key: string) {
    if (this.edittingOption == key) return "dim-config-option-score-editting";
    return this.canEditScore ? "" : "input-disable";
  }
  inputDimScore(config: StructExamScoreConfig, e: any) {
    const value = e.target.value;
    config.dimensionScore = Math.max(
      0,
      Math.min(100, Math.round(Number(value)))
    );
    config.videoQuestionScore = config.dimensionScore;
    this.changeScore(config.dimensionKey, config.dimensionScore);
    if (this.edittingDimension == config.dimensionKey) {
      this.edittingDimension = "";
    }
  }

  inputOptionScore(option: any, e: any) {
    // if(option.score < )
    const value = e.target.value;
    option.score = Math.max(-100, Math.min(100, Math.round(Number(value))));
    const config = this.selectQuestionScoreConfig;
    let maxScore = 0;
    if (config) {
      for (const option of config.choiceQuestionScoreList) {
        if (option.score > maxScore) maxScore = option.score;
      }
      config.dimensionScore = maxScore;
      config.videoQuestionScore = maxScore;

      this.changeScore(config.dimensionKey, config.dimensionScore);
    }
    if (this.edittingOption == option.optionKey) {
      this.edittingOption = "";
    }
  }
  //用户手动改填空某空分值
  inputBlankScore(i: number, e: any) {
    const config = this.blankQuestionScoreConfig;
    if (config) {
      const score = config.blankQuestionScoreList.reduce(
        (a: number, b: number) => Number(a) + Number(b),
        0
      );
      config.dimensionScore = score;
      this.changeScore(config.dimensionKey, score);
    }
  }

  //限制正整数
  setSortTo(a: any) {
    this.sortTo =
      Number(a.replace(/[^\d]/g, "")) > 0 ? Number(a.replace(/[^\d]/g, "")) : 0;
  }

  //排序
  sort() {
    if (!this.sortTo) {
      this.$message.warning("请输入正整数");
      return;
    }
    this.popShow = false;
    this.$emit("sort", this.sortTo);
  }

  mounted() {
    this.initData(this.question);
    this.onActionsChange(this.actions);
  }

  changePreparetionTime(val: number) {
    if (this.questionConfig && this.questionConfig.preparationTime != -1) {
      this.questionConfig.submitNumberLimit = 1;
    }
    if (this.questionConfig && val === -1) {
      this.questionConfig.openPreparationTimeSound = 2;
    }
  }

  @Watch("question")
  initData(to: any, from: any = null) {
    this.initScoreConfig();
    console.log("hahahaha langList", langList);

    const fk = this.initSelectQuestionConfig();
    const fk2 = this.initBlankQuestionConfig();
  }

  @Watch("actions")
  onActionsChange(to: any, from: any = null) {
    this.showMoreActions = false;
    if (this.actions && this.actions.length > 0) {
      for (const action of this.actions) {
        if (action.enable) {
          this.showMoreActions = true;
        }
      }
    }
  }

  @Emit()
  editQuestion() {
    return this.question;
  }

  @Emit()
  deleteQuestion() {
    return this.question;
  }

  @Emit()
  change() {
    return this.question.questionId;
  }

  @Emit()
  changeScore(dimKey: string, score: number) {
    return {
      question: this.question,
      dimKey: dimKey,
      score: score
    };
  }

  @Emit()
  menuItemClick(index: number) {
    return { questionId: this.question, eventId: index };
  }
}
